export const urlNavigation = `${process.env.PUBLIC_URL}/configurations/data.json`;
export const urlPages = `${process.env.PUBLIC_URL}/configurations/pages.json`;
export const urlTerms = `${process.env.PUBLIC_URL}/configurations/terms.json`;